import React, { useState, useEffect } from 'react'
import { Card, Col, Row } from 'react-bootstrap'

const MailBox = (props) => {

    const[name, setName] = useState('mailbox_v001_t002');
    const [counter, setCounter] = useState(1)

    const openImage = (name) => {
        setName(name)
    }

    useEffect(() => {
        const imageNameList = [
            'mailbox_v001_t002',
            'mailbox_v002_t001',
            'mailbox_v003_t001',
            'mailbox_v004_t001',
            'mailbox_v004_t002',
            'mailbox_v004_t003',
            'mailbox_v005_t002',
            'mailbox_v006_t002',
        ]
        // console.log(imageNameList.length)
        
      setTimeout(() => {
            setName(imageNameList[counter-1]);
            setCounter(counter+1)
        }, 5000);   
         
      }, [counter]);

      if(counter > 8) {
        setCounter(1);
    }

  return (
    <>
        <Card className='no-border rounded-0 mailbox-container container'>
            <Row>
                <Col xs={{span:12, offset:0}}>
                    <Card className='no-border rounded-0'>
                        <Card.Body className='mailbox-card-body'>
                            <Card.Title className='mailbox-title pb-3'> 3D Model Rendering </Card.Title>
                            <Card.Text className="mailbox-text">
                            Virtual 3D Product Models can be rendered from any angle, with any texture (material/color) to match real - world scenes to create hybrid images that can best highlight product use cases.
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={{span:12, offset:0}} md={{span:5, offset:0}}>
                    <Card className="no-border rounded-0 mailbox-stand container">
                        <div className='mailbox-turntable py-2'>
                            <video className='mailbox-player container' autoPlay muted loop playsInline onContextMenu={(e) => e.preventDefault()}>
                                <source src={process.env.PUBLIC_URL + "assets/mailbox/video/mailbox_turntable.mp4"} type="video/mp4"/>
                            </video>
                        </div>
                    </Card>
                </Col>
                <Col xs={{span:12, offset:0}} md={{span:7, offset:0}}>
                    <div className="mailbox-gallery-container">
                        <div className="mailbox-image-gallery container-fluid">
                            <Row className='pb-3 mailbox-gallery'>
                                <div className="col-12">
                                    <div id="mailbox_v001_t002" className="picture" >
                                        <img  className="img-fluid slide mailbox-house-viewer" src={process.env.PUBLIC_URL + "assets/mailbox/images/mailbox-house/"+name+".jpg"} alt="mailbox_v001_t002" />
                                    </div>
                                    {/* <div id="mailbox_v002_t001" className="picture" >
                                        <img style={{display: name === 'mailbox_v002_t001' ? 'block' : 'none'}} className="img-fluid slide mailbox-house-viewer" src={process.env.PUBLIC_URL + "assets/mailbox/images/mailbox-house/mailbox_v002_t001.png"} alt="mailbox_v002_t001" />
                                    </div>
                                    <div id="mailbox_v003_t001" className="picture" >
                                        <img style={{display: name === 'mailbox_v003_t001' ? 'block' : 'none'}} className="img-fluid slide mailbox-house-viewer" src={process.env.PUBLIC_URL + "assets/mailbox/images/mailbox-house/mailbox_v003_t001.png"} alt="mailbox_v003_t001" />
                                    </div>
                                    <div id="mailbox_v004_t001" className="picture" >
                                        <img style={{display: name === 'mailbox_v004_t001' ? 'block' : 'none'}} className="img-fluid slide mailbox-house-viewer" src={process.env.PUBLIC_URL + "assets/mailbox/images/mailbox-house/mailbox_v004_t001.png"} alt="mailbox_v004_t001" />
                                    </div>
                                    <div id="mailbox_v004_t002" className="picture">
                                        <img style={{display: name === 'mailbox_v004_t002' ? 'block' : 'none'}} className="img-fluid slide mailbox-house-viewer" src={process.env.PUBLIC_URL + "assets/mailbox/images/mailbox-house/mailbox_v004_t002.png"} alt="mailbox_v004_t002" />
                                    </div>
                                    <div id="mailbox_v004_t003" className="picture">
                                        <img style={{display: name === 'mailbox_v004_t003' ? 'block' : 'none'}} className="img-fluid slide mailbox-house-viewer" src={process.env.PUBLIC_URL + "assets/mailbox/images/mailbox-house/mailbox_v004_t003.png"} alt="mailbox_v004_t003" />
                                    </div>
                                    <div id="mailbox_v005_t002" className="picture">
                                        <img style={{display: name === 'mailbox_v005_t002' ? 'block' : 'none'}} className="img-fluid slide mailbox-house-viewer" src={process.env.PUBLIC_URL + "assets/mailbox/images/mailbox-house/mailbox_v005_t002.png"} alt="mailbox_v005_t002" />
                                    </div>
                                    <div id="mailbox_v006_t002" className="picture">
                                        <img style={{display: name === 'mailbox_v006_t002' ? 'block' : 'none'}} className="img-fluid slide mailbox-house-viewer" src={process.env.PUBLIC_URL + "assets/mailbox/images/mailbox-house/mailbox_v006_t002.png"} alt="mailbox_v006_t002" />
                                    </div> */}
                                </div>
                            </Row>
                            <Row className="img-responsive mailbox-gallery">
                                <Col className="mailbox-first-thumbnail">
                                    <img className={`img-fluid px-0 demo cursor ${name === "mailbox_v001_t002" ? "active" : ''}`} src={process.env.PUBLIC_URL + "assets/mailbox/images/thumbnail/mailbox_v001_t002.jpg"} onClick={() => openImage('mailbox_v001_t002')} alt="mailbox_v001_t002" />
                                </Col>
                                <Col className="mailbox-thumbnails">
                                    <img className={`img-fluid px-0 demo cursor ${name === "mailbox_v002_t001" ? "active" : ''}`} src={process.env.PUBLIC_URL + "assets/mailbox/images/thumbnail/mailbox_v002_t001.jpg"} onClick={() => openImage('mailbox_v002_t001')} alt="mailbox_v002_t001" />
                                </Col>
                                <Col className="mailbox-thumbnails">
                                    <img className={`img-fluid px-0 demo cursor ${name === "mailbox_v003_t001" ? "active" : ''}`} src={process.env.PUBLIC_URL + "assets/mailbox/images/thumbnail/mailbox_v003_t001.jpg"} onClick={() => openImage('mailbox_v003_t001')} alt="mailbox_v003_t001" />
                                </Col>
                                <Col className="mailbox-thumbnails">
                                    <img className={`img-fluid px-0 demo cursor ${name === "mailbox_v004_t001" ? "active" : ''}`} src={process.env.PUBLIC_URL + "assets/mailbox/images/thumbnail/mailbox_v004_t001.jpg"} onClick={() => openImage('mailbox_v004_t001')} alt="mailbox_v004_t001" />
                                </Col>
                                <Col className="mailbox-thumbnails">
                                    <img className={`img-fluid px-0 demo cursor ${name === "mailbox_v004_t002" ? "active" : ''}`} src={process.env.PUBLIC_URL + "assets/mailbox/images/thumbnail/mailbox_v004_t002.jpg"} onClick={() => openImage('mailbox_v004_t002')} alt="mailbox_v004_t002" />
                                </Col>
                                <Col className="mailbox-thumbnails">
                                    <img className={`img-fluid px-0 demo cursor ${name === "mailbox_v004_t003" ? "active" : ''}`} src={process.env.PUBLIC_URL + "assets/mailbox/images/thumbnail/mailbox_v004_t003.jpg"} onClick={() => openImage('mailbox_v004_t003')} alt="mailbox_v004_t003" />
                                </Col>
                                <Col className="mailbox-thumbnails">
                                    <img className={`img-fluid px-0 demo cursor ${name === "mailbox_v005_t002" ? "active" : ''}`} src={process.env.PUBLIC_URL + "assets/mailbox/images/thumbnail/mailbox_v005_t002.jpg"} onClick={() => openImage('mailbox_v005_t002')} alt="mailbox_v005_t002" />
                                </Col>
                                <Col className="mailbox-last-thumbnail">
                                    <img className={`img-fluid px-0 demo cursor ${name === "mailbox_v006_t002" ? "active" : ''}`} src={process.env.PUBLIC_URL + "assets/mailbox/images/thumbnail/mailbox_v006_t002.jpg"} onClick={() => openImage('mailbox_v006_t002')} alt="mailbox_v006_t002" />
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <Card.Img className="no-padding-x mailbox-homes-shadow" src={process.env.PUBLIC_URL + "assets/extra-common/house-section-shadow.png"}  alt="" />
                </Col>
            </Row>
        </Card>
    </>
  )
}

export default MailBox
